import { Text, Table, TableHeader, TableBody, TableRow, TableCell } from "@jsq/ds/core";
import { ArenaLockAction } from "../constants";
import * as styles from "./styles_vanilla.css";

type DefaultConfigurationTableProps = {
  selectedAction: ArenaLockAction;
};

export const DefaultConfigurationTable = ({
  selectedAction,
}: DefaultConfigurationTableProps) => {
  const rowItems = [
    {
      role: "Juniper Square Capital Events",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Capital Events Manager",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Investor Services",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Investor Services Manager",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Fund Accounting",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Fund Accounting Manager",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Onboarding",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Onboarding Manager",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Managed Close",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Managed Close Manager",
      group: "Juniper Square Administered Entities",
    },
    {
      role: "Juniper Square Operations Manager",
      group: "Juniper Square Administered Entities",
    },
  ];

  return (
    <div className={styles.accordion}>
      <div className={styles.accordionContent}>
        <Text variant="strong-sm" className={styles.defaultConfigTitle}>
          Default Arena {selectedAction === ArenaLockAction.LOCK ? "Lock" : "Unlock"}{" "}
          Configuration
        </Text>
        <Table condensed variant="muted" hasBottomBorder>
          <TableHeader>
            <TableRow>
              <TableCell header>User role</TableCell>
              <TableCell header>Entity access group</TableCell>
              <TableCell header className={styles.centeredCell}>
                Fund Administered
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rowItems.map((item) => (
              <TableRow key={item.role}>
                <TableCell>{item.role}</TableCell>
                <TableCell>{item.group}</TableCell>
                <TableCell className={styles.centeredCell}>
                  {selectedAction === ArenaLockAction.LOCK ? "yes" : "no"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
